// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y-nl","right":"styles_right__2XDVS"};